<ax-text-area  [rows]="rows" [placeholder]="placeholder"></ax-text-area>